import type { ActionItem } from 'shared/ui'
import { type ICallingListResponse } from 'entities/AICalling/api/types'
import { edit } from './edit/edit'
import { details } from './details/details'
import { deleteAction } from './delete/delete'
import { duplicate } from './duplicate/duplicate'

export const getCallingActions = ({
  item,
  onSuccessDelete,
}: {
  item: ICallingListResponse
  onSuccessDelete: () => void
}): ActionItem[] => [
  edit(item),
  details(item),
  duplicate(item),
  deleteAction(item, onSuccessDelete),
]
